import { Box, Stack, Switch, Typography } from "@mui/material";
import type { ReactNode } from "react";
import { useFieldContext } from "./form.context";

type Props = {
  label: string;
  hint?: string;
  icon?: ReactNode;
};

export function SwitchField({ label, hint, icon }: Props) {
  const field = useFieldContext<boolean>();
  const active = Boolean(field.state.value);

  return (
    <Box
      sx={{
        p: 2,
        borderRadius: 2,
        border: 1.5,
        borderColor: active ? "success.300" : "grey.200",
        cursor: "pointer",
        transition: "all 0.2s",
      }}
      onClick={() => field.handleChange(!active)}
    >
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Stack direction="row" spacing={1.5} alignItems="center">
          {icon && (
            <Box
              sx={{
                width: 32,
                height: 32,
                borderRadius: 1.5,
                bgcolor: active ? "success.200" : "grey.100",
                border: 1,
                borderColor: active ? "success.main" : "grey.300",
                color: active ? "success.main" : "grey.500",
                transition: "all 0.2s",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {icon}
            </Box>
          )}
          <Box>
            <Typography
              variant="body2"
              fontWeight={600}
              color={active ? "success.main" : "text.secondary"}
              mb={hint ? 0.25 : 0}
            >
              {label}
            </Typography>
            {hint && (
              <Typography variant="caption" color="text.secondary" sx={{ lineHeight: 1.4 }}>
                {hint}
              </Typography>
            )}
          </Box>
        </Stack>
        <Switch
          size="medium"
          checked={active}
          onChange={(_, v) => field.handleChange(v)}
          onClick={(e) => e.stopPropagation()}
        />
      </Stack>
    </Box>
  );
}
